import type {
  EarlyPayoutReportingRow,
  EarlyPayoutRuleset,
  EarlyPayoutSelector,
} from "./earlyPayoutTypes";
import type {
  EarlyPayoutEventDropdownItem,
  EarlyPayoutLeagueDropdownItem,
  EarlyPayoutMarketDropdownItem,
  EarlyPayoutSportDropdownItem,
} from "../../../queries/sportsbook/earlyPayout";

export const MOCK_SPORTS_DROPDOWN: EarlyPayoutSportDropdownItem[] = [
  { sport_id: "sr:sport:1", title: "Soccer" },
  { sport_id: "sr:sport:2", title: "Basketball" },
  { sport_id: "sr:sport:20", title: "Table Tennis" },
];

export const MOCK_LEAGUES_DROPDOWN: EarlyPayoutLeagueDropdownItem[] = [
  {
    tournament_id: "sr:tournament:32129",
    title: "TT Cup - International",
    tournament_name: "TT Cup",
    category_id: "sr:category:88",
    category_name: "International",
  },
  {
    tournament_id: "sr:tournament:36349",
    title: "Czech Liga Pro - Czech Republic",
    tournament_name: "Czech Liga Pro",
    category_id: "sr:category:1017",
    category_name: "Czech Republic",
  },
  {
    tournament_id: "sr:tournament:99999",
    title: "No Category League - International",
    tournament_name: "No Category League",
    category_id: null,
    category_name: null,
  },
  {
    tournament_id: "sr:tournament:132",
    title: "NBA - USA",
    tournament_name: "NBA",
    category_id: null,
    category_name: "USA",
  },
];

export const MOCK_EVENTS_DROPDOWN: EarlyPayoutEventDropdownItem[] = [
  {
    event_id: "sr:match:70505028",
    title: "San Antonio Spurs vs. Oklahoma City Thunder",
    event_name: "San Antonio Spurs vs. Oklahoma City Thunder",
    sport_id: "sr:sport:2",
    sport_name: "Basketball",
    tournament_id: "sr:tournament:132",
    tournament_name: "NBA",
    category_id: null,
    category_name: "USA",
    home_name: "San Antonio Spurs",
    away_name: "Oklahoma City Thunder",
  },
];

export const MOCK_MARKETS_DROPDOWN: EarlyPayoutMarketDropdownItem[] = [
  { market_id: "1", title: "1x2" },
  { market_id: "186", title: "Winner" },
  { market_id: "219", title: "Winner (incl. overtime)" },
];

export const MOCK_RULESETS: EarlyPayoutRuleset[] = [
  {
    id: "soccer-1x2",
    ruleName: "Soccer/1x2",
    ruleType: "TOTAL",
    sport: "Soccer",
    market: "1x2",
    marketId: "1",
    sportId: "sr:sport:1",
    advantage: 2,
    lines: [
      { lineValue: 1.5, timeStart: "00:00", timeEnd: "09:59" },
      { lineValue: 2, timeStart: "10:00", timeEnd: "23:59" },
    ],
  },
  {
    id: "american-football-winner",
    ruleName: "American Football/Winner",
    ruleType: "WINNER",
    sport: "American Football",
    market: "Winner (incl. overtime)",
    sportId: "sr:sport:16",
    advantage: 17,
  },
  {
    id: "baseball-winner",
    ruleName: "Baseball/Winner",
    ruleType: "WINNER",
    sport: "Baseball",
    market: "Winner (incl. extra innings)",
    marketDisplayName: "ID: 186 - Winner (incl. extra innings)",
    marketId: "186",
    sportId: "sr:sport:3",
    advantage: 5,
  },
  {
    id: "basketball-winner",
    ruleName: "Basketball/Winner",
    ruleType: "WINNER",
    sport: "Basketball",
    market: "Winner (incl. overtime)",
    sportId: "sr:sport:2",
    advantage: 20,
  },
  {
    id: "ice-hockey-winner",
    ruleName: "Ice Hockey/Winner",
    ruleType: "WINNER",
    sport: "Ice Hockey",
    market: "Winner (incl. overtime and penalties)",
    sportId: "sr:sport:4",
    advantage: 3,
  },
  {
    id: "table-tennis-winner",
    ruleName: "Table Tennis/Winner",
    ruleType: "WINNER",
    sport: "Table Tennis",
    market: "Winner",
    sportId: "sr:sport:20",
    marketId: "186",
    advantage: 1,
  },
];

export const MOCK_SELECTORS: EarlyPayoutSelector[] = [
  {
    selectorId: "7c9e6679-7425-40de-944b-e07fc1f90ae7",
    selector: "sport",
    details: "ID: 1 - Sport: Soccer",
    status: "Enabled",
    ruleId: "soccer-1x2",
    rule: {
      id: "soccer-1x2",
      ruleName: "Soccer/1x2",
      ruleType: "TOTAL",
      sport: "Soccer",
      market: "1x2",
      marketId: "1",
      sportId: "sr:sport:1",
      advantage: 2,
      lines: [
        { lineValue: 1.5, timeStart: "00:00", timeEnd: "09:59" },
        { lineValue: 2, timeStart: "10:00", timeEnd: "23:59" },
      ],
    },
  },
  {
    selectorId: "6a0a063c-9f6f-4a4d-80d6-fad2bcfe5e48",
    selector: "tournament",
    details: "ID: 132 - Sport: Basketball / Category:  / Tournament: NBA",
    status: "Enabled",
    ruleId: "123e4567-e89b-12d3-a456-426614174000",
    rule: {
      id: "123e4567-e89b-12d3-a456-426614174000",
      ruleName: "Basketball/Winner",
      ruleType: "WINNER",
      sport: "Basketball",
      market: "Winner",
      marketDisplayName: "ID: 219 - Winner",
      advantage: 10,
      sportId: "sr:sport:2",
      marketId: "219",
    },
  },
  {
    selectorId: "a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11",
    selector: "sport",
    details: "ID: 20 - Sport: Table Tennis",
    status: "Enabled",
    ruleId: "123e4567-e89b-12d3-a456-426614174001",
    rule: {
      id: "123e4567-e89b-12d3-a456-426614174001",
      ruleName: "Table Tennis/Winner",
      ruleType: "WINNER",
      sport: "Table Tennis",
      market: "Winner",
      advantage: 1,
      sportId: "sr:sport:20",
      marketId: "186",
    },
  },
];

// TODO(SPENG-2296): remove mock data once the reporting API is available.
export const MOCK_REPORTING_ROWS: EarlyPayoutReportingRow[] = [
  {
    id: "reporting-1",
    sport: "Baseball",
    league: "MLB",
    market: "ML",
    matchup: "Red Sox vs Braves",
    timeOfWin: "2:42 pm",
    scoreOnWin: "3-1",
    numberOfBets: 1000,
    settledPayout: 1000,
  },
  {
    id: "reporting-2",
    sport: "Football",
    league: "NFL",
    market: "ML",
    matchup: "Patriots vs Browns",
    timeOfWin: "4:13 pm",
    scoreOnWin: "7-14",
    numberOfBets: 250,
    settledPayout: 1040,
  },
  {
    id: "reporting-3",
    sport: "Soccer",
    league: "EPL",
    market: "1x2",
    matchup: "Juventus vs Real Madrid",
    timeOfWin: "7:51 pm",
    scoreOnWin: "0-1",
    numberOfBets: 5023,
    settledPayout: 1000,
  },
  {
    id: "reporting-4",
    sport: "Soccer",
    league: "EPL",
    market: "O/U",
    matchup: "Manchester City vs Barcelona",
    timeOfWin: "2:42 pm",
    scoreOnWin: "3-2",
    numberOfBets: 452,
    settledPayout: 1800,
  },
  {
    id: "reporting-5",
    sport: "Hockey",
    league: "NHL",
    market: "ML",
    matchup: "Bruins vs Sabres",
    timeOfWin: "3:35 pm",
    scoreOnWin: "5-3",
    numberOfBets: 602,
    settledPayout: 3000,
  },
  {
    id: "reporting-6",
    sport: "Football",
    league: "NFL",
    market: "ML",
    matchup: "Patriots vs Browns",
    timeOfWin: "4:13 pm",
    scoreOnWin: "7-14",
    numberOfBets: 250,
    settledPayout: 250,
  },
  {
    id: "reporting-7",
    sport: "Soccer",
    league: "EPL",
    market: "1x2",
    matchup: "Juventus vs Real Madrid",
    timeOfWin: "7:51 pm",
    scoreOnWin: "0-1",
    numberOfBets: 5023,
    settledPayout: 1000,
  },
  {
    id: "reporting-8",
    sport: "Soccer",
    league: "EPL",
    market: "O/U",
    matchup: "Manchester City vs Barcelona",
    timeOfWin: "2:42 pm",
    scoreOnWin: "3-2",
    numberOfBets: 452,
    settledPayout: 1000,
  },
  {
    id: "reporting-9",
    sport: "Hockey",
    league: "NHL",
    market: "ML",
    matchup: "Bruins vs Sabres",
    timeOfWin: "3:35 pm",
    scoreOnWin: "5-3",
    numberOfBets: 602,
    settledPayout: 1000,
  },
  {
    id: "reporting-10",
    sport: "Baseball",
    league: "MLB",
    market: "ML",
    matchup: "Red Sox vs Braves",
    timeOfWin: "2:42 pm",
    scoreOnWin: "3-1",
    numberOfBets: 1000,
    settledPayout: 1500,
  },
];
